export default __webpack_public_path__ + "static/media/Highland Credit Application Form.63f4da5c.pdf";